import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Tabs } from 'antd';
import { Title } from 'src/components/Layout/Typography';

import Articles from '../Articles';
import TabAlphabet from '../TabAlphabet';
import TabComplaints from '../TabComplaints';
import TabMostSearch from '../TabMostSearch';

import classes from './style.module.css';
import cn from "src/utils/cn";

const { TabPane } = Tabs;

interface TabObatProps {
	activeTab?: string;
	isCategory?: boolean;
}

const tabKeys = ['az', 'keluhan', 'dicari'];

const TabObat: FC<TabObatProps> = (props: TabObatProps) => {
	const router = useRouter();
	const tabQuery = router.query?.layout ? { layout: router.query.layout } : {};
	const [activeTab, setActiveTab] = useState<string>(props.activeTab ?? tabKeys[0]);

	useEffect(() => {
		const hash = router.asPath.split('#').splice(-1)[0];
		if (tabKeys.includes(hash)) {
			setActiveTab(hash);
		}
		if (router.asPath.includes('search=')) {
			setActiveTab(tabKeys[0]);
		}
	}, [router.asPath]);

	const handleChangeTab = (key: string) => {
		setActiveTab(key);
		router.push({
			pathname: '/obat',
			hash: key,
			query: tabQuery,
		});
	};

	return (
        <Tabs
            defaultActiveKey={activeTab}
            onChange={handleChangeTab}
            type="card"
            className={classes.tabs}
            moreIcon={false}
            tabBarExtraContent={false}
            activeKey={activeTab}
            items={[{
                key: tabKeys[0],
                label: <h2 className={cn('fs-12 fs-sm-16', classes.pane)}>Obat A-Z</h2>,

                children: <>
                    <TabAlphabet />
                </>
            }, {
                key: tabKeys[1],
                label: <h2 className={cn('fs-12 fs-sm-16', classes.pane)}>Berdasarkan Kategori</h2>,

                children: <>
                    <Title level={2} text="Pencarian Obat Berdasarkan Kategori" className={classes.title} />
                    {props.isCategory ? <Articles /> : <TabComplaints />}
                </>
            }, {
                key: tabKeys[2],
                label: <h2 className="fs-12 fs-sm-16">Banyak Dicari</h2>,

                children: <>
                    <TabMostSearch />
                </>
            }]}></Tabs>
    );
};

export default TabObat;
